import React, {Component} from 'react';
import './App.css';
import Projects from "./Projects/Projects";
import {Route} from "react-router-dom";
import Bids from "./Bids/Bids";
import Reports from "./Reports/Reports";
import AppSettings from "./Settings/AppSettings";
import {Layout} from 'antd';
import Moment from 'moment';
import {Helmet} from "react-helmet";
import {GlobalHeader} from "./Boilerplate/Menus";
import Home from "./Home";
import {BreadcrumbProvider} from "./Boilerplate/BreadcrumbContext";
import {Authenticator} from "./Security/Authenticator";
import EmulateControl from "./Boilerplate/EmulateControl";
Moment.locale('en');

const swapStyles = () => {
  const sheet = document.querySelector('[scope="style"]');
  const href = sheet.getAttribute("href");
  const isPrint = href.indexOf('print') !== -1;
  const newref = isPrint ? href.replace("print", "index") : href.replace("index", "print");
  sheet.setAttribute("href", newref);
};

const unloadStyles = () => {
  if (window.styles) return;
  let styles = {
    sheet: null,
    sheets: [],
  };
  // const sheet = document.querySelector('[scope="style"]');
  // styles.sheet = sheet.getAttribute('href');
  // sheet.removeAttribute('href');
  styles.sheets = document.head.querySelectorAll('style');
  document.head.querySelectorAll('style').forEach(e => e.parentNode.removeChild(e));
  window.styles = styles;
};

const reloadStyles = () => {
  let styles = window.styles;
  if (!styles) return;
  // const sheet = document.querySelector('[scope="style"]');
  // sheet.setAttribute('href', styles.sheet);
  styles.sheets.forEach(e => document.head.appendChild(e));
  window.styles = null;
};

const toggleStyles = () => {
  swapStyles();
  if (!window.styles) unloadStyles();
  else reloadStyles();
};

window.swapStyles = swapStyles;
window.unloadStyles = unloadStyles;
window.reloadStyles = reloadStyles;
window.toggleStyles = toggleStyles;

class App extends Component {
  state = {
    collapsed: false
  };

  handleCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  render() {
    if (this.props.hide) return null;
    const { navigation } = this.props;
    const layout = navigation ? (this.state.collapsed ? `layout-${navigation}-collapsed` : `layout-${navigation}`) : '';
    return (
      <Authenticator>
        <BreadcrumbProvider>
          <div>
            <Helmet>
              <title>cProject</title>
            </Helmet>
            <Layout>
              <GlobalHeader/>
              <EmulateControl/>
              <Layout id='cproject-layout' className={layout}>
                <Layout.Content id='content'>
                  <Route path='/' exact component={Home}/>
                  <Route path="/projects" component={Projects}/>
                  <Route path="/bids" component={Bids}/>
                  <Route path="/reports" component={Reports}/>
                  <Route path="/settings" component={AppSettings}/>
                </Layout.Content>
                <Layout.Footer id='footer'>
                  cProject ©2019
                </Layout.Footer>
              </Layout>
            </Layout>
          </div>
        </BreadcrumbProvider>
      </Authenticator>
    );
  }
}



App.defaultProps = {
  navigation: 'top'
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js